import { IsActiveMatchOptions, Router } from '@angular/router';
import { NavService } from './../../navigation/nav.service';
import { Component, input, inject, computed } from '@angular/core';
import { NavigationElement } from '../../navigation/nav.service';
import { L10N_LOCALE } from 'angular-l10n';

@Component({
  selector: 'app-nav-element',
  templateUrl: './nav-element.component.html',
  styleUrls: ['./nav-element.component.scss'],
  standalone: false,
})
export class NavElementComponent {
  readonly locale = inject(L10N_LOCALE);
  private readonly navService = inject(NavService);
  private readonly route = inject(Router);

  readonly element = input<NavigationElement>();
  readonly level = input<number>();
  readonly nested = input<boolean>();

  readonly isInRoute = computed(() => (this.element() ? this.isInRouteRecursive(this.element()!) : false));
  readonly isElementAllowed = computed(() => (this.element() ? this.navService.isAllowed(this.element()!) : false));
  readonly padding = computed(() => {
    const level = this.level() ?? 0;
    return (level >= 1 ? level * 8 : 0) + 'px';
  });
  readonly routerLinkActiveOptions = computed(() => {
    const el = this.element();
    const opts = el?.routerActiveOptions ?? {};
    return {
      paths: opts.paths ?? (el?.routerActiveExact ? 'exact' : 'subset'),
      queryParams: opts.queryParams ?? 'ignored',
      matrixParams: opts.matrixParams ?? 'ignored',
      fragment: opts.fragment ?? 'ignored',
      ...opts,
    } as IsActiveMatchOptions;
  });

  private isInRouteRecursive(navElement: NavigationElement): boolean {
    if (navElement.route && this.route.url.includes(navElement.route)) {
      return true;
    }

    let isInRoute = false;
    navElement.elements?.forEach((child) => {
      isInRoute = isInRoute || this.isInRouteRecursive(child);
    });

    return isInRoute;
  }
}
